var _path, _path2, _path3, _path4, _path5, _path6, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 36,
    viewBox: "0 0 70 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00911 17.8269C8.85092 17.8269 10.3346 19.0036 10.3858 20.871H3.65804C3.93943 18.9268 5.29521 17.8269 7.00911 17.8269ZM13.7368 24.836H9.87415C9.4137 25.7825 8.56954 26.5499 7.03469 26.5499C5.24404 26.5499 3.81153 25.3732 3.63246 23.2756H13.9926C14.0694 22.8151 14.095 22.3547 14.095 21.8942C14.095 17.6734 11.2043 14.8851 7.11144 14.8851C2.9162 14.8851 0 17.7246 0 22.2012C0 26.6522 2.99294 29.5173 7.11144 29.5173C10.616 29.5173 12.9694 27.4452 13.7368 24.836Z",
    fill: "#013590"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2253 22.15C15.2253 26.5755 18.0904 29.5173 21.6972 29.5173C23.9228 29.5173 25.5088 28.494 26.3529 27.1894V29.287H29.9854V10.3573H26.3529V17.085C25.3809 15.7548 23.5902 14.8851 21.7228 14.8851C18.0904 14.8851 15.2253 17.7246 15.2253 22.15ZM26.3785 22.2012C26.3785 24.8872 24.5879 26.3708 22.6181 26.3708C20.6996 26.3708 18.8834 24.836 18.8834 22.15C18.8834 19.464 20.6996 18.0315 22.6181 18.0315C24.5879 18.0315 26.3785 19.5152 26.3785 22.2012Z",
    fill: "#013590"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5143 25.0151L41.8562 15.1153H37.8401L43.519 28.9289L40.4493 35.9892H44.2608L53.035 15.1153H49.2235L45.5143 25.0151Z",
    fill: "#013590"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7865 29.287H58.4189V18.0571H60.9003V15.1153H58.4189V14.527C58.4189 12.941 59.0073 12.3782 60.7468 12.4293V9.41083C56.7562 9.3085 54.7865 10.9201 54.7865 14.3991V15.1153H53.1749V18.0571H54.7865V29.287Z",
    fill: "#013590"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2211 24.8872C63.2211 28.1359 65.0373 29.287 67.7489 29.287H70V26.2685H68.3373C67.2117 26.2685 66.828 25.8592 66.828 24.9127V18.0571H70V15.1153H66.828V11.6108H63.2211V15.1153H61.5328V18.0571H63.2211V24.8872Z",
    fill: "#013590"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8516 7.11614L34.2606 2.70711C34.6511 2.31658 35.2843 2.31658 35.6748 2.70711L40.0838 7.11614",
    stroke: "#6CD4FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.1172,
    y: 3.70312,
    width: 1.70538,
    height: 25.5807,
    rx: 0.85269,
    fill: "#6CD4FF",
    stroke: "#6CD4FF",
    strokeWidth: 1.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.49fc89152d41d4868337736374629614.svg";
export { ForwardRef as ReactComponent };